import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

const getSession = () => {
  const storageRaw = sessionStorage.getItem('ddesp');
  if (!storageRaw) return { emp: 0, uid: 0 };

  const usersRt = base64_decode(storageRaw);
  const users = JSON.parse(usersRt);
  return {
    emp: users?.[0] || 0,
    uid: users?.[3] || 0,
  };
};

const adaptTicketRow = (row) => {
  const createdAt  = row?.created_at   ? new Date(row.created_at)   : null;
  const updatedAt  = row?.updated_at   ? new Date(row.updated_at)   : null;
  const resolvidoEm = row?.resolvido_em ? new Date(row.resolvido_em) : null;

  return {
    ticket_id:       row?.ticket_id  ? Number(row.ticket_id) : null,
    status:          row?.status     || '',
    assunto:         row?.assunto    || '',
    descricao:       row?.descricao  || '',
    area:            row?.area       || '',
    tipo:            row?.tipo       || '',
    prioridade:      row?.prioridade != null ? Number(row.prioridade) : null,
    total_mensagens: row?.total_mensagens != null ? Number(row.total_mensagens) : 0,
    created_at:      createdAt,
    updated_at:      updatedAt,
    resolvido_em:    resolvidoEm,
    _raw: row,
  };
};

export const RestTicketsGet = async (config) => {
  const caminho = (config?.dest || '').trim();
  const users = sessionStorage.getItem('ddesp');
  const { emp, uid } = getSession();
  const token = users ? JSON.parse(base64_decode(users))?.[14] : '';

  switch (caminho) {
    case 'diag':
    case 'debug': {
      return new Promise((resolve, reject) => {
        try {
          const payload = config?.dataPost || {};
          const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
             headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('tickets'),
              ll: base64_encode('diag'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, { message: 'Falha na requisição', details }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'mine':
    case 'myTickets': {
      return new Promise((resolve, reject) => {
        try {
          const payload = config?.dataPost || {};
          const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('tickets'),
              ll: base64_encode('mine'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data) {
              try {
                const rows = JSON.parse(base64_decode(data)) || [];
                resolve([200, rows.map(adaptTicketRow)]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, { message: 'Falha na requisição', details }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'all':
    case 'allTickets': {
      return new Promise((resolve, reject) => {
        try {
          const payload = config?.dataPost || {};
          const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('tickets'),
              ll: base64_encode('all'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data) {
              try {
                const rows = JSON.parse(base64_decode(data)) || [];
                resolve([200, rows.map(adaptTicketRow)]);
              } catch {
                reject([400, {message: 'Resposta inválida'}]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, {message: 'Falha na requisição', details}]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'detail': {
      return new Promise((resolve, reject) => {
        try {
          const payload = config?.dataPost || {};
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('tickets'),
              ll: base64_encode('detail'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, {message: 'Resposta inválida'}]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, {message: 'Falha na requisição', details}]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

/**
 * RestTicketsPost — gerencia requisições POST para /api/tickets/
 * dest: 'create'  → cria um novo ticket
 */
export const RestTicketsPost = async (config) => {
  const { emp, uid } = getSession();
  const token = sessionStorage.getItem('ddesp') ? JSON.parse(base64_decode(sessionStorage.getItem('ddesp')))?.[14] : '';

  // Suporte a multipart/form-data (FormData) — usado no create com anexos
  if (typeof FormData !== 'undefined' && config?.data instanceof FormData) {
    const incoming = config.data;
    const caminho = String(incoming.get('dest') || '').trim();

    if (caminho !== 'create' && caminho !== 'addAnexo') {
      return new Promise((resolve, reject) => reject([400, { message: 'Destino inválido' }]));
    }

    if (caminho === 'addAnexo') {
      const ticketId = String(incoming.get('dataPost[ticketId]') || incoming.get('ticket_id') || '').trim();
      if (!ticketId) {
        return new Promise((resolve, reject) => reject([400, { message: 'ticketId obrigatório' }]));
      }

      const payload = { ticketId: Number(ticketId) };
      const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

      const fd = new FormData();
      fd.append('pp', base64_encode('tickets'));
      fd.append('ll', base64_encode('addAnexo'));
      fd.append('dd', base64_encode(JSON.stringify(dataPost_)));

      const hasAttachmentsFlag = incoming.get('has_attachments');
      if (hasAttachmentsFlag != null && String(hasAttachmentsFlag).trim() !== '') {
        fd.append('has_attachments', String(hasAttachmentsFlag));
      }

      const filesA = incoming.getAll('attachments') || [];
      const filesB = incoming.getAll('attachments[]') || [];
      [...filesA, ...filesB].forEach((f) => {
        if (f) fd.append('attachments[]', f);
      });

      return new Promise((resolve, reject) => {
        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'POST',
            dataType: 'json',
            data: fd,
            processData: false,
            contentType: false,
            headers: {
              Authorization: 'Bearer ' + token,
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, { message: 'Falha na requisição', details }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    const payload = {
      area: String(incoming.get('dataPost[area]') || '').trim(),
      tipo: String(incoming.get('dataPost[tipo]') || '').trim(),
      assunto: String(incoming.get('dataPost[assunto]') || '').trim(),
      descricao: String(incoming.get('dataPost[descricao]') || '').trim(),
    };

    const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

    const fd = new FormData();
    fd.append('pp', base64_encode('tickets'));
    fd.append('ll', base64_encode('create'));
    fd.append('dd', base64_encode(JSON.stringify(dataPost_)));

    const hasAttachmentsFlag = incoming.get('has_attachments');
    if (hasAttachmentsFlag != null && String(hasAttachmentsFlag).trim() !== '') {
      fd.append('has_attachments', String(hasAttachmentsFlag));
    }

    // arquivos podem vir como attachments (sem []) do modal
    const filesA = incoming.getAll('attachments') || [];
    const filesB = incoming.getAll('attachments[]') || [];
    [...filesA, ...filesB].forEach((f) => {
      if (f) fd.append('attachments[]', f);
    });

    return new Promise((resolve, reject) => {
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'POST',
          dataType: 'json',
          data: fd,
          processData: false,
          contentType: false,
          headers: {
            Authorization: 'Bearer ' + token,
          },
          success: function (data) {
            try {
              const out = JSON.parse(base64_decode(data));
              resolve([200, out]);
            } catch {
              reject([400, { message: 'Resposta inválida' }]);
            }
          },
          error: function (xhr) {
            const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
            reject([400, { message: 'Falha na requisição', details }]);
          },
        });
      } catch (err) {
        reject([500, { message: String(err) }]);
      }
    });
  }

  let body = {};
  try { body = JSON.parse(config?.data || '{}'); } catch { body = {}; }

  const caminho = (body?.dest || '').trim();

  switch (caminho) {
    case 'create': {
      return new Promise((resolve, reject) => {
        try {
          const payload = body?.dataPost || {};
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'POST',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('tickets'),
              ll: base64_encode('create'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, {message: 'Resposta inválida'}]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, {message: 'Falha na requisição', details}]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'sendMessage':
    case 'enviarMensagem': {
      return new Promise((resolve, reject) => {
        try {
          const payload = body?.dataPost || {};
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'POST',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('tickets'),
              ll: base64_encode('sendMessage'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, {message: 'Resposta inválida'}]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, {message: 'Falha na requisição', details}]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'setStatus':
    case 'alterarStatus': {
      return new Promise((resolve, reject) => {
        try {
          const payload = body?.dataPost || {};
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'POST',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('tickets'),
              ll: base64_encode('setStatus'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, {message: 'Resposta inválida'}]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, {message: 'Falha na requisição', details}]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'deleteAnexo':
    case 'delAnexo':
    case 'removeAnexo': {
      return new Promise((resolve, reject) => {
        try {
          const payload = body?.dataPost || {};
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'POST',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('tickets'),
              ll: base64_encode('deleteAnexo'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, {message: 'Resposta inválida'}]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, {message: 'Falha na requisição', details}]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota POST não encontrada' }]));
  }
};
